/* 2009-2018 Copyright Ridecell Inc. All rights reserved. */

export default async function applyIsLoading(promise) {
  try {
    this.setState({ isLoading: true })
    return await promise
  } finally {
    this.setState({ isLoading: false })
  }
}
